import {
  SET_CONTENT_CLASSIFICATION,
  SET_PARENTAL_ACTION,
  SET_PARENTAL_CONTROL,
  SET_PARENTAL_STATE_SNAPSHOT,
  SET_PIN,
  SET_PROFILE_BUTTON_FOCUS,
  SET_PROFILE_LANG,
  SET_PROFILE_NAME,
  SET_PROFILE_PHOTO,
  SET_PROFILES,
} from '@actions/profileActions'
import { ParentalControlStep } from '@enums/profile.enum'
import { ParentalStateSnapshot, ProfileState } from '@interfaces/index'
import { ProfileImagesData } from 'sdk/services/config/types/config'
import { UserProfile } from 'sdk/services/storage/profiles/types/profilesManager'

interface SetProfileButtonFocusAction {
  type: typeof SET_PROFILE_BUTTON_FOCUS
  payload: {
    focusedButton: string
  }
}

interface SetProfilesAction {
  type: typeof SET_PROFILES
  payload: {
    profiles: UserProfile[]
  }
}

interface SetParentalActionAction {
  type: typeof SET_PARENTAL_ACTION
  payload: {
    parentalAction: ParentalControlStep | null
  }
}

interface SetParentalControlAction {
  type: typeof SET_PARENTAL_CONTROL
  payload: {
    value: null | boolean
  }
}

interface SetPinAction {
  type: typeof SET_PIN
  payload: {
    pin: string | null
  }
}

interface SetContentClassificationAction {
  type: typeof SET_CONTENT_CLASSIFICATION
  payload: {
    contentClassification: string | null
  }
}

interface SetParentalStateSnapshotAction {
  type: typeof SET_PARENTAL_STATE_SNAPSHOT
  payload: {
    snapshot: ParentalStateSnapshot | null
  }
}
interface SetProfileNameAction {
  type: typeof SET_PROFILE_NAME
  payload: {
    name: string
  }
}
interface SetProfileLangAction {
  type: typeof SET_PROFILE_LANG
  payload: {
    lang: string
  }
}

interface SetProfilePhotoAction {
  type: typeof SET_PROFILE_PHOTO
  payload: {
    photo: ProfileImagesData | null
  }
}

type ProfileAction =
  | SetProfileButtonFocusAction
  | SetProfilesAction
  | SetParentalActionAction
  | SetParentalControlAction
  | SetPinAction
  | SetContentClassificationAction
  | SetParentalStateSnapshotAction
  | SetProfileNameAction
  | SetProfileLangAction
  | SetProfilePhotoAction

const initialState: ProfileState = {
  focusedButton: '',
  profiles: [],
  parentalAction: null,
  parentalControl: null,
  pin: null,
  contentClassification: null,
  parentalStateSnapshot: null,
  lang: '',
  name: '',
  photo: null,
}

export default function profileReducer(state = initialState, action: ProfileAction) {
  if (action.type === SET_PROFILE_BUTTON_FOCUS) {
    return {
      ...state,
      focusedButton: action.payload.focusedButton,
    }
  } else if (action.type === SET_PROFILES) {
    return {
      ...state,
      profiles: action.payload.profiles,
    }
  } else if (action.type === SET_PARENTAL_ACTION) {
    return {
      ...state,
      parentalAction: action.payload.parentalAction,
    }
  } else if (action.type === SET_PARENTAL_CONTROL) {
    return {
      ...state,
      parentalControl: action.payload.value,
    }
  } else if (action.type === SET_PIN) {
    return {
      ...state,
      pin: action.payload.pin,
    }
  } else if (action.type === SET_CONTENT_CLASSIFICATION) {
    return {
      ...state,
      contentClassification: action.payload.contentClassification,
    }
  } else if (action.type === SET_PARENTAL_STATE_SNAPSHOT) {
    return {
      ...state,
      parentalStateSnapshot: action.payload.snapshot,
    }
  } else if (action.type === SET_PROFILE_NAME) {
    return {
      ...state,
      name: action.payload.name,
    }
  } else if (action.type === SET_PROFILE_LANG) {
    return {
      ...state,
      lang: action.payload.lang,
    }
  } else if (action.type === SET_PROFILE_PHOTO) {
    return {
      ...state,
      photo: action.payload.photo,
    }
  } else {
    return state
  }
}
